export default {
    add(name, value) {
        const params = new URLSearchParams(window.location.search);

        if (!params.has(name)) {
            params.append(name, value);
        }
        window.history.pushState(null, null, `?${params.toString()}`);
    },
    del(name) {
        const params = new URLSearchParams(window.location.search);

        params.delete(name);
        window.history.pushState(null, null, `?${params.toString()}`);
    },
};
